// Shader configuration for control panel buttons
// Adjust these values to customize glow effects

export interface ShaderConfig {
    color: string;      // Hex color code
    intensity: number;  // 0.0 - 2.0+ (brightness multiplier)
    speed?: number;     // Animation speed multiplier (future enhancement)
}

export const AI_MODEL_SHADER_CONFIGS: Record<string, ShaderConfig> = {
    openai: {
        color: '#10A37F',      // OpenAI signature green
        intensity: 1.2,
    },
    anthropic: {
        color: '#D4A574',      // Warm gold (Anthropic brand)
        intensity: 1.1,       // Matches gemini/copilot for consistency
    },
    gemini: {
        color: '#4285F4',      // Google blue
        intensity: 1.1,
    },
    grok: {
        color: '#FF6B35',      // Energetic orange
        intensity: 1.3,        // Higher intensity for impact
    },
    huggingface: {
        color: '#FFD21E',      // Vibrant yellow
        intensity: 1.0,
    },
    copilot: {
        color: '#8B5CF6',      // GitHub purple
        intensity: 1.1,
    },
    whiteboard: {
        color: '#06B6D4',      // Cyan (communication/collaboration)
        intensity: 1.0,
    },
    border: {
        color: '#F59E0B',      // Amber (UI control)
        intensity: 0.9,
    },
    share: {
        color: '#10B981',      // Emerald (positive action)
        intensity: 0.95,
    },
};

// Global shader settings
export const SHADER_SETTINGS = {
    // Canvas size multiplier relative to button
    canvasScale: 1.2,
    
    // Animation speeds (seconds)
    pulseSpeed: 2.0,       // Main pulse animation
    fastPulseSpeed: 4.0,   // Secondary shimmer
    noiseSpeed: 0.3,       // Background noise movement
    
    // Performance
    reduceOnMobile: true,  // Lower quality on mobile devices
    respectReducedMotion: true, // Honor accessibility preferences
    
    // Visual quality
    antialiasing: true,
    preserveDrawingBuffer: false, // Set true if you need screenshots
};

// Utility function to get shader config with fallback
export const getShaderConfig = (key: string): ShaderConfig => {
    return AI_MODEL_SHADER_CONFIGS[key] || {
        color: '#6B6FFF',  // Default purple
        intensity: 1.0,
    };
};
